import { useContext } from 'react';
import { ApisContext } from './ApisContext';

export const useSweepApi = () => {
  const { dashboardAPI } = useContext(ApisContext);

  return dashboardAPI;
};
